import request from '@/utils/request'
import { AxiosPagination } from '@/typings/common'

export interface LbuSalesWorkReportParams {
    queryType?: number
    employeeNoList?: string[]
    deptLevel4List?: string[]
    deptLevel5List?: string[]
    startTime?: string
    endTime?: string
}

export type LbuSalesWorkReportResult = AxiosPagination<any>

export function salesWorkList(data?: LbuSalesWorkReportParams) {
  return request.post<LbuSalesWorkReportResult>('/lbu/api/kpi/report/list', data)
}
